import { createEffect, createEvent, createStore, sample } from 'effector';
import { IMixRoot, IRecipesWarehouse } from '../ts';
import { IExclusiveRecipe } from '@/widgets/recipe/types';
import { RecipeMixingService } from '../services/recipe-mixing.service';
import { DiContainer } from '@/modules/di/di-container';
import { ANALYTICAL_MIXING_SELECTED_WAREHOUSE } from '@/shared/constants/local-storage-keys.constant';

const recipeMixingService = DiContainer.get(RecipeMixingService);

export const setSelectedRecipeStore = createEvent<IRecipesWarehouse>();
export const $selectedRecipeStore = createStore<IRecipesWarehouse | null>(null).on(
  setSelectedRecipeStore,
  (_s, payload) => {
    localStorage.setItem(ANALYTICAL_MIXING_SELECTED_WAREHOUSE, String(payload.id))
    return payload;
  },
);

type sortValue = { label: string; val: string; active: boolean };
type sortOptions = { sortBy: sortValue[]; order: 'asc' | 'desc' };

// export const setWarehousesSort = createEvent<sortOptions>();
// export const $warehousesSort = createStore<sortOptions>({
//   sortBy: 'profit',
//   order: 'asc',
// }).on(setWarehousesSort, (_s, payload) => payload);

var mixesSortInitialState: sortOptions = {
  order: 'desc',
  sortBy: [
    {
      label: 'выгоде от микса',
      val: 'profit',
      active: true,
    },
    {
      label: 'стоимости логистики',
      val: 'priceLogistic',
      active: false,
    },
    {
      label: 'стоимости микса',
      val: 'priceTotal',
      active: false,
    },
    {
      label: 'цене покупателя',
      val: 'priceTon',
      active: false,
    },
    {
      label: 'весу микса',
      val: 'weight',
      active: false,
    },
    {
      label: 'покупателю',
      val: 'buyer',
      active: false,
    },
  ],
};

export const setMixesSortOrder = createEvent<'asc' | 'desc'>();
export const setMixSortValue = createEvent<sortValue[]>();
export const $mixesSort = createStore<sortOptions>(mixesSortInitialState)
  .on(setMixesSortOrder, (state, payload) => {
    return { ...state, order: payload };
  })
  .on(setMixSortValue, (state, payload) => ({ ...state, sortBy: payload }));

const leftoversSortInitialState: sortOptions = {
  order: 'asc',
  sortBy: [
    {
      label: 'номеру рукава',
      val: 'order',
      active: true,
    },
    {
      label: 'стоимости остатка',
      val: 'price',
      active: false,
    },
  ],
};

export const setLeftoversSortOrder = createEvent<'asc' | 'desc'>();
export const setLeftoversSortValue = createEvent<sortValue[]>();
export const $leftoversSort = createStore<sortOptions>(leftoversSortInitialState)
  .on(setLeftoversSortOrder, (state, payload) => {
    return { ...state, order: payload };
  })
  .on(setLeftoversSortValue, (state, payload) => ({ ...state, sortBy: payload }));

export const setMoistureChangesDensity = createEvent<boolean>();
export const $moistureChangesDensity = createStore(true).on(
  setMoistureChangesDensity,
  (_state, payload) => payload,
);

export const setMarkeredMixes = createEvent<number[]>();
export const setMarkeredMixesToInitialState = createEvent();
export const $markeredMixes = createStore<number[] | null>([])
  .on(setMarkeredMixesToInitialState, () => [])
  .on(setMarkeredMixes, (_s, p) => p);


export const setSelectedMix = createEvent<IExclusiveRecipe>();
export const $selectedMix = createStore<IExclusiveRecipe | null>(null);
$selectedMix.on(setSelectedMix, (_s, p) => p);

const setRecipeMixData = createEvent();
export const $recipeMixData = createStore<IMixRoot | null>(null).on(setRecipeMixData, (_s, p) => p);
export const $recipeMixDataLoadingStatus = createStore<{ error: boolean | Error, loading: boolean }>({ error: false, loading: false });
export const setRecipeMixDataloadingStatus = createEvent<{ error: boolean | Error, loading: boolean }>();
$recipeMixDataLoadingStatus.on(setRecipeMixDataloadingStatus, (_s, p) => p);


export const fetchRecipeMixById = createEffect(async (id: number) => {
  try {
    setRecipeMixDataloadingStatus({ error: false, loading: true });
    const res = await recipeMixingService.getRecipeMix(id);
    setRecipeMixDataloadingStatus({ error: false, loading: false });
    return res;
  } catch (err) {
    setRecipeMixDataloadingStatus({ error: err as Error, loading: false });
  }
  
});

sample({
  clock: fetchRecipeMixById.doneData,
  target: setRecipeMixData,
});

export const $sleeveToView = createStore<string | null>(null);
export const setSleeveToView = createEvent<string | null>();
$sleeveToView.on(setSleeveToView, (_S, p) => p);